import { useEffect } from "react";
import Spacer from "../../components/global/navigation/Spacer";
import useRequireEnabledVariation from "../../hooks/useRequireEnabledVariation";
import useUrlSearchParams from "../../hooks/useUrlSearchParams";
import { navigate } from "../../services/navigation";

type UseSearchParamSkusProps = { onEmpty: { navigateTo: string } };
const useSearchParamSkus = ({ onEmpty }: UseSearchParamSkusProps) => {
  const searchParams = useUrlSearchParams();
  const idsParam = searchParams.get("ids");

  useEffect(() => {
    if (!idsParam) {
      navigate(onEmpty.navigateTo);
    }
  }, [idsParam, onEmpty.navigateTo]);

  return idsParam ? idsParam.split(",") : [];
};

const QuizResults = () => {
  const skus = useSearchParamSkus({
    onEmpty: { navigateTo: "/quiz" },
  });
  const enabled = useRequireEnabledVariation("enable-quiz", {
    onDisabled: { navigateTo: "/" },
  });

  if (!enabled || skus.length === 0) {
    return null;
  }

  return (
    <>
      <Spacer />
      <h1>Quiz Results</h1>
      <p>SKUs: {skus.join(", ")}</p>
    </>
  );
};

export default QuizResults;
